module.exports = __webpack_public_path__ + "img/image-13.39cb3e53.jpg";